<template>
	<v-container class="pa-0">
		
		<v-row>
			<v-col cols="12" lg="9">
				<GroupHeader></GroupHeader>
				<GroupDocuments />
			</v-col>
			<v-col cols="12" lg="3">
				<GroupSideBar />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import GroupSideBar from '@/components/GroupSideBar.vue';
import GroupDocuments from '../components/GroupDocuments.vue';
import GroupHeader from '../components/GroupHeader.vue';
export default {
	name: 'ArquivosGrupo',
	components: {
		GroupSideBar,
		GroupHeader,
		GroupDocuments,
	},
};
</script>
